import React from "react";
import { Message } from "../../../components";
import { COLOR } from "../../../components/theme";

export const MerchantSettingsError = () => (
  <Message
    severity="warning-or-significant"
    bg={COLOR.RED_100}
    title="Invalid request"
  >
    Sorry, merchant setup does not look correct. Please try again.
  </Message>
);
